import { render, staticRenderFns } from "./TaxFilter.vue?vue&type=template&id=2c143db4"
import script from "./TaxFilter.vue?vue&type=script&lang=js"
export * from "./TaxFilter.vue?vue&type=script&lang=js"
import style0 from "./TaxFilter.vue?vue&type=style&index=0&id=2c143db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports